"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.PLP_HEADER_AREA = void 0;
const PLP_HEADER_AREA = exports.PLP_HEADER_AREA = 'plp-header-area';
